var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2565 28.6739C23.4275 28.6739 22.7567 28.0116 22.7567 27.1931V19.0398C22.7567 18.2213 23.4275 17.5589 24.2565 17.5589C25.0855 17.5589 25.7563 18.2213 25.7563 19.0398V27.1931C25.7563 28.0116 25.0855 28.6739 24.2565 28.6739Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0553 32.127C26.0553 33.1084 25.2495 33.904 24.2555 33.904C23.2615 33.904 22.4557 33.1084 22.4557 32.127C22.4557 31.1456 23.2615 30.35 24.2555 30.35C25.2495 30.35 26.0553 31.1456 26.0553 32.127Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3416 40H10.661C8.9766 40 7.4709 39.141 6.63018 37.7007C5.78945 36.2632 5.78945 34.5452 6.63311 33.1077L19.9734 10.2965C20.8112 8.859 22.3198 8 24.0013 8C25.6827 8 27.1914 8.859 28.0321 10.2965L41.3695 33.1077C42.2102 34.5481 42.2102 36.2661 41.3695 37.7035C40.5287 39.141 39.023 40 37.3416 40ZM24.0013 10.9617C23.7142 10.9617 22.9994 11.0398 22.5718 11.7773L9.22852 34.5886C8.7979 35.3261 9.08498 35.9769 9.22852 36.2227C9.37206 36.4685 9.79975 37.0383 10.661 37.0383H37.3416C38.2028 37.0383 38.6276 36.4685 38.7711 36.2227C38.9146 35.9769 39.2047 35.3261 38.7711 34.5886L25.4337 11.7773C25.0031 11.0398 24.2884 10.9617 24.0013 10.9617Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.284c2dcf.svg";
export { ForwardRef as ReactComponent };